import { render, staticRenderFns } from "./customEditor.vue?vue&type=template&id=60345beb"
import script from "./customEditor.vue?vue&type=script&lang=js"
export * from "./customEditor.vue?vue&type=script&lang=js"
import style0 from "./customEditor.vue?vue&type=style&index=0&id=60345beb&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_c2c4f8d10a02e12364bd9a7337709f82/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports